import { formatInt } from "@/lib/format";

/** `counts` largest first, ties in alphabetical order; the first `limit`. */
export function rankCounts(
  counts: Readonly<Record<string, number>>,
  limit?: number,
): Array<[string, number]> {
  return Object.entries(counts)
    .sort((a, b) => b[1] - a[1] || a[0].localeCompare(b[0], "de-CH"))
    .slice(0, limit);
}

interface Props {
  /** What the rows are; the table's first column head and its name. */
  title: string;
  counts: Readonly<Record<string, number>>;
  /** What is counted: the count column's head. */
  unit: string;
  /** The words for a key; the key itself by default (a place, a Berufsfeld). */
  label?: (key: string) => string;
  /** The one row of a table without counts. */
  empty: string;
  limit?: number;
}

/** A ranked count list, largest first; an empty one keeps its head. */
export function CountTable({ title, counts, unit, label = (key) => key, empty, limit }: Props) {
  const rows = rankCounts(counts, limit);
  return (
    <table class="table count-table" aria-label={title}>
      <thead>
        <tr>
          <th>{title}</th>
          <th>{unit}</th>
        </tr>
      </thead>
      <tbody>
        {rows.length === 0 ? (
          <tr>
            <td colSpan={2} class="muted">
              {empty}
            </td>
          </tr>
        ) : (
          rows.map(([key, n]) => (
            <tr key={key}>
              <td>{label(key)}</td>
              <td>{formatInt(n)}</td>
            </tr>
          ))
        )}
      </tbody>
    </table>
  );
}
